import {
  listPackagingBomsApi,
  getPackagingBomApi,
  createPackagingBomApi,
  activatePackagingBomApi,
  listPackagingMapsApi,
  upsertPackagingMapApi,
  createPackagingBomLineApi,
  updatePackagingBomLineApi,
  deletePackagingBomLineApi,
  saveActivePackagingBomApi,
  getPackagingBomFamilyVersionsApi,
  comparePackagingBomsApi,
  deletePackagingBomApi,
  PackagingBomsApiClientError,
} from './apiClient'

export const packagingBomService = {
  list: listPackagingBomsApi,
  getById: getPackagingBomApi,
  create: createPackagingBomApi,
  activate: activatePackagingBomApi,
  listMaps: listPackagingMapsApi,
  upsertMap: upsertPackagingMapApi,
  createLine: createPackagingBomLineApi,
  updateLine: updatePackagingBomLineApi,
  deleteLine: deletePackagingBomLineApi,
  saveActive: saveActivePackagingBomApi,
  getFamilyVersions: getPackagingBomFamilyVersionsApi,
  compare: comparePackagingBomsApi,
  delete: deletePackagingBomApi,
}

export {
  listPackagingBomsApi,
  getPackagingBomApi,
  createPackagingBomApi,
  activatePackagingBomApi,
  listPackagingMapsApi,
  upsertPackagingMapApi,
  createPackagingBomLineApi,
  updatePackagingBomLineApi,
  deletePackagingBomLineApi,
  saveActivePackagingBomApi,
  getPackagingBomFamilyVersionsApi,
  comparePackagingBomsApi,
  deletePackagingBomApi,
}

export { PackagingBomsApiClientError }
export type {
  PackagingBom,
  PackagingBomDetail,
  PackagingBomLine,
  PackagingBomStatus,
  ProductPackagingMap,
  PackagingBomCreateInput,
} from './types'
